import { DialogContent, DialogContentText, useTheme, useMediaQuery } from '@mui/material';
import { PmiDialog } from 'shell/components/shared/dialog';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

interface NewRegistrationPersonModalProps {
  open: boolean;
  onClose: (open?: boolean) => void;
  onYes: (open?: boolean) => void;
  onProceed?: () => void;
  onNo: (open?: boolean) => void;
  disabled?: boolean;
  id?: string;
  idAnpr?: string;
  isFromTable?: boolean;
  isFromTableAccordion?: boolean;
}

const NewRegistrationPersonModal = ({
  open,
  onClose,
  onYes,
  onNo,
  disabled,
  id,
  idAnpr,
  onProceed,
  isFromTable,
}: NewRegistrationPersonModalProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  const contentText = idAnpr
    ? 'Il soggetto cercato è irreperibile si vuole modificare la persona'
    : id
    ? 'Il soggetto cercato si trova su SIPO si vuole modificare la persona'
    : 'Non risultano presenti in archivio posizioni con i dati richiesti, si vuole procedere con la registrazione della persona';

  return (
    <PmiDialog
      open={open}
      fullScreen={fullScreen}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableScrollLock
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="cdmBrand" color="white">
        Attenzione
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <DialogContentText id="alert-dialog-description" color="grey">
          {isFromTable
            ? `${contentText} o si vuole proseguire con l'operazione in corso?`
            : `${contentText}?`}
        </DialogContentText>
      </DialogContent>
      <div className="pmi-d-flex pmi-justify-content-end pmi-pb-3 pmi-px-3">
        {isFromTable && onProceed ? (
          <div className="pmi-mr-3 pmi-pr-1 pmi-w-25">
            <PmiButton
              fullWidth
              onClick={() => {
                if (onProceed) onProceed();
              }}
              variant="contained"
              color="primary"
              disabled={disabled}
            >
              Prosegui
            </PmiButton>
          </div>
        ) : undefined}
        <div className="pmi-mr-3 pmi-pr-1 pmi-w-25">
          <PmiButton
            fullWidth
            onClick={() => onYes(false)}
            variant="contained"
            color="primary"
            disabled={disabled}
          >
            {id || idAnpr ? 'Procedi alla modifica' : 'Procedi registrazione'}
          </PmiButton>
        </div>
        <div className="pmi-w-25">
          <PmiButton fullWidth onClick={() => onNo(false)} variant="outlined" color="cdmBrand">
            Annulla
          </PmiButton>
        </div>
      </div>
    </PmiDialog>
  );
};

NewRegistrationPersonModal.displayName = 'New registration person Modal component';

export default NewRegistrationPersonModal;
